import branch from 'branch-sdk';
import { store } from '../../store';

let isBranchInitialized = false;

// Check if Branch should be enabled
const isBranchEnabled = process.env.REACT_APP_BRANCH_IO_ENABLED === 'true';

// Initialize Branch
export const initBranch = async () => {
  if (!isBranchEnabled) {
    // console.warn('Branch SDK is disabled for this environment.');
    return Promise.resolve('Branch SDK is disabled');
  }

  return new Promise((resolve, reject) => {
    if (!isBranchInitialized) {
      branch.init(process.env.REACT_APP_BRANCH_IO_KEY, (err, data) => {
        if (err) {
          console.error('Branch initialization error:', err);
          reject(err);
        } else {
          // console.log('Branch initialized:', data);
          isBranchInitialized = true;
          resolve(data);
        }
      });
    } else {
      resolve('Branch already initialized');
    }
  });
};

// Create a Branch Link
export const createBranchLink = async (linkData) => {
  if (!isBranchEnabled) {
    // console.warn('Branch SDK is disabled for this environment.');
    return Promise.resolve('Branch SDK is disabled');
  }

  try {
    const link = await branch.createLink(linkData);
    // console.log('Branch link created:', link);
    return link;
  } catch (error) {
    console.error('Error creating Branch link:', error);
    throw error;
  }
};

// Track Event
export const trackEvent = (eventName, eventData = {}) => {
  if (!isBranchEnabled) {
    return;
  }
  
  const { user } = store.getState();
  branch.setIdentity(user?.userId || '');

  const customData = {
    server: process.env.REACT_APP_API_URL,
    email: user?.email || '',
    phone: user?.phone || '',
    userId: user?.userId || '',
    ...eventData,
  };

  try {
    branch.logEvent(eventName, customData);
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};